import { render, staticRenderFns } from "./SubjectRow.vue?vue&type=template&id=5e2bd345&scoped=true"
import script from "@/components/subject-row/SubjectRow.ts?vue&type=script&lang=ts&external"
export * from "@/components/subject-row/SubjectRow.ts?vue&type=script&lang=ts&external"
import style0 from "./subject-row.scss?vue&type=style&index=0&id=5e2bd345&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2bd345",
  null
  
)

export default component.exports